import { handleActions } from 'redux-actions';
import { IDLE } from 'settings/constants/apiState';
import { cloneDeep, get } from 'lodash-es';

import {
  requestGetTeamListAction,
  requestTeamTransactionPermissionsAction,
} from 'store/actions/teamList';
import { appLogoutAction } from 'store/actions/app';
import { setTeamListSendDateAction } from 'store/actions/clientsList';

const initialData = {
  state: IDLE,
  data: null,
  teamTransactionPermissions: [],
  meta: {},
};

export default handleActions(
  {
    [requestGetTeamListAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data', initialData.data) || state.data,
      meta: get(payload, 'meta', initialData.meta),
    }),
    [requestTeamTransactionPermissionsAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      teamTransactionPermissions:
        get(payload.data, 'TransactionPermissions', initialData.teamTransactionPermissions) ||
        state.teamTransactionPermissions,
    }),
    [setTeamListSendDateAction]: (state, { payload }) => {
      const data = cloneDeep(state?.data);
      const toUpdate = data?.find(({ Id }) => Id === payload);
      if (toUpdate) toUpdate.InviteSentAt = new Date().toISOString();
      return {
        ...state,
        data,
      };
    },
    [appLogoutAction]: () => cloneDeep(initialData),
  },
  initialData,
);
